// extracted by mini-css-extract-plugin
export default {"container":"styles__container___Jbnug","textarea":"styles__textarea___AkzDR","characterCount":"styles__characterCount___DB9Jh","bottomSection":"styles__bottomSection___zCy9p"};